import PropertyForm from "../../components/Property/PropertyForm";

export default function PropertyAddPage() {
  return <PropertyForm />;
}
